<template>
  <div v-if="articles.length" class="layout-grid mx-auto max-w-screen-xxl">
    <div class="layout-grid-contain">
      <div
        class="grid grid-cols-2 gap-x-16 gap-y-40 md:grid-cols-4 md:gap-x-24 md:gap-y-48"
      >
        <div
          v-for="(article, index) in articles"
          :key="article.id"
          :class="
            index === 0 ? 'col-span-2 row-span-2 row-start-1' : 'col-span-1'
          "
        >
          <MagazineHighlightGridTeaser
            :article="article"
            :image-style="getImageStyle(index)"
            :main="index === 0"
          />
        </div>
      </div>

      <ButtonsLinkButton
        class="link-button mt-80 text-center md:mt-112"
        :url="url"
        icon-end="arrow-right"
      >
        {{ $texts('moreStories', 'More Stories') }}
      </ButtonsLinkButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type MagazineArticleTeaserFragment } from '#graphql-operations'

const { $texts } = useEasyTexts()

defineProps<{
  articles: MagazineArticleTeaserFragment[]
  url: string
}>()

const imageStyleFirst = defineImageStyle({
  type: 'sizes',
  aspectRatio: 3 / 4,
  sizes: {
    sm: 735,
    md: 430,
    lg: 550,
    xxl: 636,
  },
})

const imageStyleSecondAndFourth = defineImageStyle({
  type: 'sizes',
  aspectRatio: 3 / 4,
  sizes: {
    sm: 360,
    md: 202,
    lg: 265,
    xxl: 310,
  },
})

const imageStyleThird = defineImageStyle({
  type: 'sizes',
  aspectRatio: 2 / 3,
  sizes: {
    sm: 360,
    md: 202,
    lg: 265,
    xxl: 310,
  },
})

const imageStyleFifth = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    sm: 360,
    md: 202,
    lg: 265,
    xxl: 310,
  },
})

const getImageStyle = (index: number) => {
  if (index === 0) {
    return imageStyleFirst
  } else if (index === 1 || index === 3) {
    return imageStyleSecondAndFourth
  } else if (index === 2) {
    return imageStyleThird
  }

  return imageStyleFifth
}

defineOptions({
  name: 'MagazineHighlightGridNews',
})
</script>
